import classNames from "classnames";
import React from "react";
import { CSS_CLASSES } from "./list-css-classes";
import { ListItem, ListItemProps } from "./list.types";

export const ListItemElement = <M extends ListItem = ListItem>({ item }: ListItemProps<M>) => {
  const { text, icon, className } = item;

  return (
    <div className={classNames(CSS_CLASSES.LIST_ITEM_ELEMENT, className)}>
      {icon && <div className={CSS_CLASSES.LIST_ICON}>{icon} </div>}
      {text}
    </div>
  );
};
